var exports = {
  "Nr": "x43aef4ae--8631f8--card",
  "Qc": "x43aef4ae--8631f8--place-number",
  "EC": "x43aef4ae--8631f8--place-wrapper",
  "Kk": "x43aef4ae--8631f8--icon",
  "vt": "x43aef4ae--8631f8--description-icon",
  "rt": "x43aef4ae--8631f8--description-icon--inner",
};

module.exports = exports;
